<template>
  <div>
    <GroupTree v-model="AreaId" GroupFlag="area"></GroupTree>
    <div>所选ID： {{ AreaId }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      AreaId: "",
    };
  },
  methods: {},
};
</script>